import * as z from 'zod';
export const ReservationItemPriceMode = z.enum(['catalog', 'per_step', 'total']);
